import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from '../locales/en.json';
import esTranslations from '../locales/es.json';
import frTranslations from '../locales/fr.json';

// Translation resources
const resources = {
  en: {
    common: enTranslations.common,
    auth: enTranslations.auth,
    navigation: enTranslations.navigation,
    dashboard: enTranslations.dashboard,
    employee: enTranslations.employee,
    attendance: enTranslations.attendance,
    leave: enTranslations.leave,
    payroll: enTranslations.payroll,
    master: enTranslations.master,
    loans: enTranslations.loans
  },
  es: {
    common: esTranslations.common,
    auth: esTranslations.auth,
    navigation: esTranslations.navigation,
    dashboard: esTranslations.dashboard,
    employee: esTranslations.employee,
    attendance: esTranslations.attendance,
    leave: esTranslations.leave,
    payroll: esTranslations.payroll,
    master: esTranslations.master,
    loans: esTranslations.loans || {}
  },
  fr: {
    common: frTranslations.common,
    auth: frTranslations.auth,
    navigation: frTranslations.navigation,
    dashboard: frTranslations.dashboard,
    employee: frTranslations.employee,
    attendance: frTranslations.attendance,
    leave: frTranslations.leave,
    payroll: frTranslations.payroll,
    master: frTranslations.master,
    loans: frTranslations.loans || {}
  }
};

// alias en-US to en resources to ensure keys are available when the browser reports en-US
resources['en-US'] = resources.en;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // prefer 'en' when browser reports variants like 'en-US'
    fallbackLng: { 'en-US': ['en'], default: ['en'] },
    // normalize language code to base language (e.g. 'en-US' -> 'en')
    load: 'languageOnly',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    react: {
      useSuspense: false,
    },

  // Use common as the default namespace
  defaultNS: 'common',
  ns: ['common', 'auth', 'navigation', 'dashboard', 'employee', 'attendance', 'leave', 'payroll', 'master', 'loans'],
  });

export default i18n;
